import * as ko from "knockout";
import entityBase from "entityBase";
import { model } from "entitiesE";
import { part } from "entitiesE";
import { c_model_structure_consumables_view } from "entitiesE";
import * as _ from "lodash";
import { c_model_info, place, task_management_extended, warranty_coverage } from "organized";

export class product extends entityBase {
  product_id: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  place_id: KnockoutObservable<string>;
  place_id_owned_by: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;
  model: KnockoutObservable<model>;
  part: KnockoutObservable<part>;
  place: KnockoutObservable<place>;
  consumables_view: KnockoutObservableArray<c_model_structure_consumables_view>;
  product_tasks: KnockoutObservableArray<task_management_extended>;
  asset_id: KnockoutObservable<string>;
  hostname: KnockoutObservable<string>;
  warranty_coverage: KnockoutObservableArray<warranty_coverage>;
  c_model_info: KnockoutObservable<c_model_info>;

  constructor(item: any) {
    super();
    this.model_id = ko.observable(item.model_id).extend({ maxLength: 128 });
    this.part_id = ko.observable(item.part_id).extend({ maxLength: 128 });
    this.place_id = ko.observable(item.place_id).extend({ maxLength: 32 });
    this.place_id_owned_by = ko.observable(item.place_id_owned_by).extend({ maxLength: 32 });
    this.product_id = ko.observable(item.product_id).extend({ maxLength: 32 });
    this.serial_id = ko.observable(item.serial_id).extend({ maxLength: 128 });
    this.model = ko.observable();
    this.part = ko.observable();
    this.place = ko.observable();
    this.consumables_view = ko.observableArray();
    this.product_tasks = ko.observableArray();
    this.asset_id = ko.observable(item.asset_id);
    this.hostname = ko.observable();
    this.warranty_coverage = ko.observableArray();
    if (item.c_product_ext) {
      this.hostname = ko.observable(
        Array.isArray(item.c_product_ext) ? item.c_product_ext[0].hostname : item.c_product_ext.hostname
      );
    } else if (item.c_product_iot_data_view) {
      this.hostname = ko.observable(
        Array.isArray(item.c_product_iot_data_view)
          ? item.c_product_iot_data_view[0].hostname
          : item.c_product_iot_data_view.hostname
      );
    }
    if (item.model) {
      this.model(new model(item.model));
    }
    if (item.part) {
      this.part(new part(item.part));
    }
    if (item.place) {
      this.place(new place(item.place));
    }
    if (item.c_model_structure_consumables_view) {
      this.consumables_view(
        _.map(item.c_model_structure_consumables_view, (o) => {
          return new c_model_structure_consumables_view(o);
        })
      );
    }
    if (item.task) {
      if (!Array.isArray(item.task)) item.task = [item.task];
      this.product_tasks(
        _.map(item.task, (o) => {
          return new task_management_extended(o);
        })
      );
    }

    this.warranty_coverage = <KnockoutObservableArray<warranty_coverage>>(
      this.loadRelation(item, warranty_coverage, "warranty_coverage", "array")
    );

    this.c_model_info = <KnockoutObservable<c_model_info>>this.loadRelation(item, c_model_info, "c_model_info");
  }
}
